import React from "react";
import AddonVariantModals from "@components/addonVariantModals";

const addonVariantModalContent = {
  pa_owner_car: {
    badge: { text: "Mandatory by law", type: "DANGER" },
    heading: "Select the <span>coverage amount</span> for your Personal Accident Cover",
    description:
      "Accidents can lead to huge medical bills, permanent disabilities, or death, which can impact your savings. With a Personal Accident cover:",
    coverageList: [
      "You’ll get 100% compensation (full sum insured) <b>in case of permanent disability</b> (loss of limbs or eyes).",
      "You'll get 50% compensation <b>in case of permanent disability</b> (loss of one eye or limb)..",
      "Your nominee gets 100% compensation (full sum insured) <b>in the event of death</b>"
    ],
    removeCtaText: "Remove",
    primaryCtaText: "Add cover",
    secondaryCtaType: "DANGER",
    showSecondaryCta: true
  },
  rsa_outstation_keyprotect_combo_car: {
    badge: { text: "Peace of mind cover", type: "PREMIUM" },
    heading:
      "Extra Car Protection<br/><span style='color:rgba(124, 71, 225, 1)'>2 options available<span/>",
    removeCtaText: "Remove",
    primaryCtaText: "Add cover"
  },
  rsa_car: {
    badge: { text: "Peace of mind cover", type: "PREMIUM" },
    heading:
      "Roadside Assistance<br/><span style='color:rgba(124, 71, 225, 1)'>2 options available<span/>",
    removeCtaText: "Remove",
    primaryCtaText: "Add cover"
  }
};

const RenewalPreviewOfferVariantModal = (props: any) => (
  <AddonVariantModals
    {...props}
    addonVariantModalContent={addonVariantModalContent}
  />
);

export default RenewalPreviewOfferVariantModal;
